const activity = [
  {
    path: '/get-coupon',
    name: 'get-coupon',
    component: () => import(/* webpackChunkName: "cityList" */ '@/pages/activity/coupon'),
    meta: {
      title: '福利大放送',
      login: true
    }
  },
  {
    path: '/get-coupon-v2',
    name: 'get-coupon-v2',
    component: () => import(/* webpackChunkName: "cityList" */ '@/pages/activity/couponV2'),
    meta: {
      title: '福利大放送',
      login: true
    }
  },
  {
    path: '/activity-gifts',
    component: () => import(/* webpackChunkName: "inviteGifts" */ '@/pages/inviteGifts/index'),
    name: 'activity-gifts',
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '袋鼠健康'
      }
    }
  },
  {
    path: '/activity-detail',
    component: () => import(/* webpackChunkName: "inviteDetail" */ '@/pages/inviteGifts/inviteDetail'),
    name: 'activity-detail',
    meta: {
      title: '袋鼠健康',
      login: true
    }
  },
  {
    path: '/activity-rule',
    component: () => import(/* webpackChunkName: "inviteRule" */ '@/pages/inviteGifts/inviteRule'),
    name: 'activity-rule',
    meta: {
      title: '袋鼠健康',
      login: true
    }
  },
  {
    path: '/activity-share',
    name: 'activity-share',
    component: () => import(/* webpackChunkName: "activityshare" */ '@/pages/inviteGifts/share'),
    meta: {
      title: '健康管理平台'
    }
  }
]

export default activity
